import { DeleteColors } from '@/connection/theme-packs';
import { RootState } from '@/store/main';
import { ContentReducerCreator, ContentState } from '../types';
import { cannotDeleteToast } from '../utils';

const deleteThemePackReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number, { getState }) => {
      const state = (getState() as RootState).content as ContentState;
      return await DeleteColors(Object.keys(state.contentMarkedForDeletion).map(Number), channel);
    },
    {
      fulfilled: (state, action) => {
        if (action.payload.cannotDelete.length) {
          const cannotDeleteSet = new Set(action.payload.cannotDelete || []);

          const errorMessage =
            state.themePacks
              ?.filter((themePack) => cannotDeleteSet.has(themePack.color_pack))
              .map((themePack) => themePack.title)
              .join(', ') || '';
          cannotDeleteToast(errorMessage);
        }

        if (state.themePacks) {
          state.themePacks = state.themePacks.filter(
            (themePack) => !action.payload.deletedColors.includes(themePack.color_pack)
          );
          state.contentMarkedForDeletion = {};
        }
      },
    }
  );
};

export default deleteThemePackReducer;
